// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 5.94"><path d="M14 1a1 1 0 00-1.55-.84L7 3.74 1.55.17a1 1 0 10-1.1 1.67l6 3.94a1 1 0 001.1 0l6-3.93A1 1 0 0014 1z"/></svg>
);

export default fn;
